import type { FaireProductEntity } from "../../entity_types/product";

export const p_74wpcj8bgy: FaireProductEntity = {
  token: "p_74wpcj8bgy",
  type: "product",
  name: "Cin Cin Martini Card - Celebration Greeting Card",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/a65093388b3239320f34ac68570ef540a2b36efeff5a079748b09385a4191539.png",
  galleryImageUrls: [],
  priceDollars: 2.75,
  description: "A card made for celebrating in style. Perfect for birthdays, promotions, engagements, housewarmings, or any moment that calls for raising a glass.\n\nGood to know: \n * Blank on the inside \n * A2 \n * Includes colored envelope \n * Individually wrapped in a cellophane sleeve or plastic free with a removable sticker clasp. \n",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:07.353Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
